// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from 'controllers/application';

import HelloController from 'controllers/hello_controller';
import ModalFormController from './modal_form_controller.js';
import PersistentLabEdit from './persistent_lab_edit_controller.js';
import DragDrop from './drag_drop_controller.js';
import ConsoleStory from './console_story_controller.js';
import UnauthorizedController from './unauthorized_controller.js';
application.register( 'hello', HelloController );
application.register( 'modal-form', ModalFormController );
application.register( 'persistent-lab', PersistentLabEdit );
application.register( 'drag-drop', DragDrop );
application.register( 'console_story', ConsoleStory );
application.register( 'unauthorized', UnauthorizedController );
